import React, { useEffect, useState } from "react";
import "./Home.css";
import { Link } from "react-router-dom";
import { getDownloadURL, ref } from "firebase/storage";
import { storage } from "../../firebase";

interface ImageLinkProps {
    imgPath: string;
    to: string;
    title: string;
}
function ImageLink(props: ImageLinkProps): React.JSX.Element {
    const { title, imgPath, to } = props;
    const [imageUrl, setImageUrl] = useState<string | null>(null);
    const imageRef = ref(storage, imgPath);

    useEffect(() => {
        const fetchImgUrl = async () => {
            try {
                const url = await getDownloadURL(imageRef);
                setImageUrl(url);
            } catch (error) {
                console.error("Error: Failed to fetch image url: ", error);
            }
        };

        fetchImgUrl();
    }, []);

    return (
        <Link to={to} className="image-link">
            <div className="img-container">
                <div className="centered-text">{title}</div>
                {imageUrl && <img src={imageUrl} draggable={false} />}
                <div className="overlay"></div>
            </div>
        </Link>
    );
}

export default function Home(): React.JSX.Element {
    document.title = "Tomas Ordonez";
    return (
        <div className="home-page">
            <h1>Tomas Ordonez Gonzalez</h1>
            <nav className="home-nav">
                <ImageLink to="/about" imgPath="Photography/Portugal/lisboa-tram1.jpg" title="About me" />
                <ImageLink to="/contact" imgPath="Photography/Portugal/lisboa-house2.jpg" title="Contact" />
                <ImageLink to="/photography" imgPath="Photography/Portugal/lisboa-tram2.jpg" title="Photography" />
            </nav>
        </div>
    );
}
